import toURL from '@homeaway/search-url-parser/dist/transpiled/toURL';
import createReducer from '../../utils/createReducer';
import actionPrefix from '../../utils/actionPrefix';
import { getRecommendedDestinations } from '../../api/clients/recommendedDestinations';

const initialState = {
  loading: false,
  data: [],
  title: '',
  subtitle: ''
};

const prefix = actionPrefix('recommendedDestinations');

// Actions
const FETCH_REQUEST = prefix('FETCH_REQUEST');
const FETCH_ERROR = prefix('FETCH_ERROR');
const FETCH_SUCCESS = prefix('FETCH_SUCCESS');

// Reusable utility functions
function addSerpUrl(data, options) {
  return data.reduce((acc, item) => {
    acc.push({
      ...item,
      destinationUrl: toURL({
        q: item.simpleDestinationName,
        departure: options.checkOut,
        arrival: options.checkIn,
        ...options.guests
      })
    });
    return acc;
  }, []);
}

// Reducers
export default createReducer(initialState, {
  [FETCH_REQUEST](state, { payload }) {
    return {
      ...state,
      ...payload,
      loading: true
    };
  },
  [FETCH_ERROR](state, { payload }) {
    return {
      ...initialState,
      error: payload
    };
  },
  [FETCH_SUCCESS](state, { payload }) {
    const { data, searchbox, ...props } = payload;
    const destinations = addSerpUrl(data, searchbox);
    return {
      ...state,
      ...props,
      loading: false,
      data: destinations
    };
  }
});

// Action creators
export const request = payload => ({
  type: FETCH_REQUEST,
  payload
});

export const throwError = payload => ({
  type: FETCH_ERROR,
  payload
});

export const success = payload => ({
  type: FETCH_SUCCESS,
  payload
});

// Effects
export const fetchRecommendedDestinations = options => (dispatch, getState) => {
  dispatch(request(options));
  const { system: { siteName }} = getState();

  return getRecommendedDestinations(options, siteName)
    .then((data) => {
      const { content: { searchbox }} = getState();
      dispatch(success({ ...data, searchbox }));
    })
    .catch(({ message }) => dispatch(throwError(message)));
};
